import User from "@/models/User";

export default class UserTransformer {
    transform (data) {
        return new User(
            data.id,
            data.firstName,
            data.lastName,
            data.email,
            data.userName,
            data.expiresIn,
            data.activated,
            data.organizationId,
            data.accessForAllSubOrgs
        )
    }
}
